import React, { useEffect, useState } from 'react';
import { PageLink, PageTitle } from '../../layout/core';
import '../settlements/SettlementReconcile.scss';
import { GoBackBtn } from '../header/GoBackBtn';
import { useParams } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { useOrdersContext } from '../../store/order/order-context';
import { fetchSettlementsDetailsData } from '../../store/order/actions/settlements';
import { exportCSVSettlementsDetails } from '../../store/order/actions/exports';
import { TablesNames } from '../../store/tables/tables-context';
import { Table } from '../table/Table';
import { checkRoles, CLAIMS } from '../../utils/roles-helper';
import { useLocation } from 'react-router';
import { SettlementsDetailsInformation } from './SettlementsDetailsInformation';
import { OrderStatus } from '../orders/OrderStatus';
import {
	fetchPartnerSettlementsData,
	fetchSettlementDataById,
} from '../../store/payments/actions/settlements';
import { ISettlementsTableRowData } from '../../interfaces/funds';
import { ISettlementDetailsData } from '../../store/order/order-interfaces';
import { ExportCSVButton } from '../form/ExportCSVButton';


export const settlementsBreadCrumbs = (returnUrl: string): PageLink[] => [
	{
		title: 'MENU.SETTLEMENTS',
		path: returnUrl,
		isSeparator: false,
		isActive: false
	},
	{
		title: '',
		path: '',
		isSeparator: true,
		isActive: false
	}
];

export const SettlementsDetails = (): JSX.Element => {
	const { id: detailId } = useParams();
	const { pathname, state } = useLocation();
	const authUser = useSelector<RootState>(({ auth }) => auth, shallowEqual);

	const getReturnUrl = (): string => {
		if (state?.returnUrl) {
			return state.returnUrl;
		} else {
			return pathname.includes('funds') ? '/funds/settlements' : '/settlements';
		}
	};

	const { orderContextState, dispatch } = useOrdersContext();
	const { isExportCSVLoading } = orderContextState;

	const [settlementsDataById, setSettlementsDataById] = useState<ISettlementsTableRowData>(null);
	const [loadingDataById, setLoadingDataById] = useState<boolean>(true);
	const [settlementDetailsData, setSettlementDetailsData] = useState<ISettlementDetailsData>(null);
	const [loadingDetailsData, setLoadingDetailsData] = useState<boolean>(true);

	const fetchData = async (): Promise<void> => {
		setLoadingDataById(true);

		const dataById = await fetchSettlementDataById(detailId );

		// if (checkRoles(authUser, CLAIMS.SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_MERCHANT_FINANCE)) {
		// 	dataById = await fetchSettlementDataById(detailId );
		// 	// TODO check partners permissions
		// } else if (checkRoles(authUser, CLAIMS.PARTNER_ADMIN) || checkRoles(authUser, CLAIMS.INTEGRATION_PARTNER_ADMIN)) {
		// 	const { rows } = await fetchPartnerSettlementsData({});
    //
		// 	dataById = rows?.find((el) => el.id === detailId);
		// }

		setSettlementsDataById(dataById);

		setLoadingDataById(false);
	};

	useEffect(() => {
		void fetchData();
	}, []);

	const listener = async (searchParams: any): Promise<void> => {
		setLoadingDetailsData(true);

		const data = await fetchSettlementsDetailsData(detailId, searchParams);

		setSettlementDetailsData(data);

		setLoadingDetailsData(false);
	};

	const breadCrumbs = settlementsBreadCrumbs(getReturnUrl());

	return (
		<>
			<PageTitle breadcrumbs={breadCrumbs}>Reconcile</PageTitle>

			<div className="d-flex align-items-center justify-content-between mb-5">
				<GoBackBtn path={getReturnUrl()}/>
				{checkRoles(authUser, CLAIMS.SUPER_ADMIN) && (
					<OrderStatus statusName={settlementsDataById?.batchType} title="Type"/>
				)}
			</div>

			<div className="card mb-5">
				<SettlementsDetailsInformation
					loading={loadingDataById}
					settlementDetailsDataById={settlementsDataById}
				/>
			</div>

			<Table
				name={TablesNames.settlementDetailsTableData}
				data={settlementDetailsData?.rows ?? []}
				isLoading={loadingDetailsData}
				totalItemCount={settlementDetailsData?.totalItemCount}
				queryParamsListener={listener}
				toolbarCustomAction={
					<ExportCSVButton
						orderTotalItemCount={settlementDetailsData?.totalItemCount}
						isExportCSVLoading={isExportCSVLoading}
						exportCSV={async (): Promise<void> => await exportCSVSettlementsDetails(dispatch, detailId, settlementDetailsData?.totalItemCount)}
					/>
				}
			/>
		</>
	);
};
